<template>
    <rkm-area
        class="pb-1"
        title="Coleta de materiais para exames"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col
                class="mb-2"
                cols="12"
            >
                <rkm-form-checkbox
                    v-for="(coletaMaterial, index) in data.form.posConsulta.coletasMateriais"
                    :key="index"
                    :value="coletaMaterial.id"
                    @change.native="handleColetaMaterialChange"
                    inline
                >
                    {{coletaMaterial.nome}}
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    methods: {
        handleColetaMaterialChange(event) {
            const coletaMaterial = this.data.form.posConsulta.coletasMateriais.find(coletaMaterial => coletaMaterial.id === parseInt(event.target.value))

            if (event.target.checked) {
                this.data.model.posConsulta.coletasMateriais.push(parseInt(event.target.value))
            } else {
                this.data.model.posConsulta.coletasMateriais.splice(this.data.model.posConsulta.coletasMateriais.indexOf(parseInt(event.target.value)) , 1)
            }

            if (coletaMaterial.codigo) {
                this.$emit('coletaMaterialChange', {
                    checked: event.target.checked,
                    codigo: coletaMaterial.codigo,
                })
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>